export default __webpack_public_path__ + "static/media/loader-trans.29b8e601.gif";